import React from 'react';
import './ChatMessage.component.scss';
import { EChatUserType, IChatMessageProps } from '../../../domain/chat.interfaces';

export function ChatMessageComponent(props: IChatMessageProps) {

  const {message} = props;

  function createMarkup(html: string) {
    return {__html: html};
  }

  return (
    <div className={`message-row d-flex ${(message.userType === EChatUserType.SENT) ? 'justify-content-end sent' : 'justify-content-start received'}`}>
      <div className='message-container'>
        <div className='message'>
          <div className='name'>{message.name}</div>
          <div className='message-text'>
            <span dangerouslySetInnerHTML={createMarkup(message.message)}></span>
            <span className='time'></span>
          </div>
          <div className='time bottom'>{message.time}</div>
        </div>
      </div>
    </div>
  );
}
